import { useQuery } from "@tanstack/react-query"
import { customerImportStatusQuery } from "../lib/customerImportStatusQuery"

export function useCustomerImportStatusQuery(id: string | undefined) {
  return useQuery({
    ...customerImportStatusQuery(id ?? ""),
    enabled: !!id,
  })
}
